import PhoneInput from "react-phone-input-2";

export default function BillingForm({ phoneNumber, handlePhoneChange }) {
  return (
    <div className="mt-2 flex flex-col gap-3">
      <div className="flex flex-col gap-1 mt-2">
        <label
          htmlFor="email"
          className="font-semibold">
          Email
        </label>
        <input
          type="email"
          id="email"
          placeholder="Enter email"
          className="w-full px-4 py-2 text-sm border-2 rounded-lg dark:bg-slate-700 dark:border-slate-600 focus:ring-2 focus:ring-green-500 focus:outline-none dark:focus:ring-green-500"
          required
        />
      </div>
      <div className="flex flex-col gap-1">
        <label
          htmlFor="firstName"
          className="font-semibold">
          First Name
        </label>
        <input
          type="text"
          id="firstName"
          placeholder="Enter first name"
          className="w-full px-4 py-2 text-sm border-2 rounded-lg dark:bg-slate-700 dark:border-slate-600 focus:ring-2 focus:ring-green-500 focus:outline-none dark:focus:ring-green-500"
          required
        />
      </div>

      <div className="flex flex-col gap-1">
        <label
          htmlFor="lastName"
          className="font-semibold">
          Last Name
        </label>
        <input
          type="text"
          id="lastName"
          placeholder="Enter last name"
          className="w-full px-4 py-2 text-sm border-2 rounded-lg border-slate-200 dark:bg-slate-700 dark:border-slate-600 focus:ring-2 focus:ring-green-500 focus:outline-none dark:focus:ring-green-500"
          required
        />
      </div>

      <div className="flex flex-col gap-1">
        <label
          htmlFor="phoneNumber"
          className="font-semibold">
          Phone
        </label>
        <div className="relative w-full ">
          <PhoneInput
            inputProps={{
              id: "phoneNumber",
              name: "phoneNumber",
              placeholder: "Enter phone number",
            }}
            country={"ph"}
            required
            value={phoneNumber}
            onChange={handlePhoneChange}
            countryCodeEditable={false}
            dropdownClass="absolute bottom-0 -translate-y-6 w-full border rounded-lg shadow-lg dark:text-gray-800"
          />
        </div>
      </div>
    </div>
  );
}
